<div class="m-portlet">
    <div class="m-portlet__head">
        <div class="m-portlet__head-caption">
            <div class="m-portlet__head-title">
                <span class="m-portlet__head-icon m--hide">
                    <i class="la la-gear"></i>
                </span>
                <h3 class="m-portlet__head-text">{{data.title}}</h3>
            </div>
        </div>
        <div class="m-portlet__head-tools">
            <button color="warn" type="button" mat-raised-button matTooltip="İndir" (click)="indir()">
                İndir
            </button>&nbsp;
            <button color="accent" type="button" mat-raised-button mat-dialog-close cdkFocusInitial matTooltip="Kapat">
                Kapat
            </button>
        </div>
    </div>
    <div class="m-form">
        <div class="m-portlet__body">
            <pdf-viewer [src]="pdfData" [render-text]="true" style="display: block;"></pdf-viewer>
        </div>
        <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
            <div class="m-form__actions m-form__actions--solid">
                <div class="row text-right">
                    <div class="col-lg-12">
                        <button color="warn" type="button" mat-raised-button matTooltip="Yazdır" (click)="indir()">
                            İndir
                        </button>&nbsp;
                        <button color="primary" type="button" mat-raised-button mat-dialog-close cdkFocusInitial
                            matTooltip="Kapat">
                            Kapat
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>